import { EditorType } from '../types'

export const CKEditorLanguagesMap = {
  'en-US': 'en',
  'es-ES': 'es',
  'pt-PT': 'pt',
}

export const EditorTypes = [
  EditorType.BALLOON,
  EditorType.CLASSIC,
  EditorType.INLINE,
]
